// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_k4-0";
export var discountCodeInput = "_k4-1";